module.exports = __webpack_public_path__ + "img/order.3ce4f64d.png";